jQuery(document).ready(function($) {

	// $('.scroll-to-form a').on('click', function(e) {
	// 	e.preventDefault();
	// 	return false;
	// });

	// scroll to form
	// $(window).on('load', function() {
		$('.scroll-to-form a').on('click', function(e) {
			e.preventDefault();
			
			$('html, body').animate({
				'scrollTop': $('.get-in-touch-content').offset().top - 150
			});
	
			return false;
		});
	// });

	
	var isMobile = $(window).width();

	if (isMobile > 640) {
		// toggle navigation
		$('#nav-icon4').on('mouseenter', function() {
			$(this).toggleClass('open');
			$('.drop-nav').toggleClass('open-nav');
		});
	} else {
		$('#nav-icon4').on('touchstart', function() {
			$(this).toggleClass('open');
			$('.drop-nav').toggleClass('open-nav');
		});
	}

	
	// toggle navigation
	// $('#nav-icon4').on('mouseenter', function() {
	// 	$(this).toggleClass('open');
	// 	$('.drop-nav').toggleClass('open-nav');
	// });


	// open & close header search form
	$('.search-toggle').on('click', function() {
		$('#header-search').toggleClass('open-search');
	});


	// services buttons
	$('.service-options .wp-block-button').on('click', function() {
		var index = $(this).index();
		
		$('html, body').animate({
			'scrollTop': $('#' + index).offset().top - 150
		});
	});


	// mobile service options dropdown
	if (isMobile <= 768) {
		var dropDown = $('<select class="mobile-service-select"></select>');
		var buttons = $('.service-options a');

		buttons.each(function() {
			var option = $('<option>' + $(this).text() + '</option>');
			option.appendTo(dropDown);
		});

		$('.service-options .wp-block-buttons').hide();
		$('.service-options').append(dropDown);
	}

	$('.mobile-service-select').on('change', function() {
		var index = $('.mobile-service-select option:selected').index();
		
		$('html, body').animate({
			'scrollTop': $('#' + index).offset().top - 150
		});
	});
	

	// single service hovers
	$('.single-service').on('mouseenter', function() {
		$(this).find('.hover-element').addClass('dotted');
	});
	$('.single-service').on('mouseleave', function() {
		$(this).find('.hover-element').removeClass('dotted');
	});


	// clean up read more link text
	var test = $('.related-articles .excerpt-read-more');
	$.each(test, function(i, e) {
		var test = $(this).text().split('...');
		var noArrows = test[1].split('»');
		
		$(this).text(noArrows[0]);
	});

});